module.exports = __webpack_public_path__ + "img/pains.b770aa8e.png";